import { css, CSSResult } from 'lit'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csColorBackground, csColorBorder, csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cscPaper = {
  borderRadius: css`var(--csc-paper-border-radius, ${csBorder.radiusMinimal})`,
  rowGap: css`var(--csc-paper-row-gap, ${csSpacing.spacing05})`,
  headingGap: css`var(--csc-paper-heading-gap, ${csSpacing.spacing04})`,
  paddingBlock: css`var(--csc-paper-padding-y, ${csSpacing.spacing06})`,
  paddingInline: css`var(--csc-paper-padding-x, ${csSpacing.spacing06})`,
  height: css`var(--csc-paper-height, auto)`,
  largePaddingBlock: css`var(--csc-paper-large-padding-y, ${csSpacing.spacing07})`,
  largePaddingInline: css`var(--csc-paper-large-padding-x, ${csSpacing.spacing07})`,
  extraLargePaddingBlock: css`var(--csc-paper-extra-large-padding-y, ${csSpacing.spacing08})`,
  extraLargePaddingInline: css`var(--csc-paper-extra-large-padding-x, ${csSpacing.spacing08})`,

  primaryBackgroundColor: css`var(--csc-paper-primary-background-color, ${csColorBackground.primary})`,
  secondaryBackgroundColor: css`var(--csc-paper-secondary-background-color, ${csColorBackground.secondary})`,
  errorBackgroundColor: css`var(--csc-paper-error-background-color, ${csColorBackground.error})`,
  infoBackgroundColor: css`var(--csc-paper-info-background-color, ${csColorBackground.info})`,
  successBackgroundColor: css`var(--csc-paper-success-background-color, ${csColorBackground.success})`,
  warningBackgroundColor: css`var(--csc-paper-warning-background-color, ${csColorBackground.warning})`,

  borderedBackgroundColor: css`var(--csc-paper-bordered-background-color, ${csColorBackground.primary})`,
  borderedBorderWidth: css`var(--csc-paper-bordered-border-width, ${csBorder.width})`,
  borderedPrimaryBorderColor: css`var(--csc-paper-bordered-primary-border-color, ${csColorBorder.light})`,
  borderedSecondaryBorderColor: css`var(--csc-paper-bordered-secondary-border-color, ${csColorBorder.dark})`,
  borderedErrorBorderColor: css`var(--csc-paper-bordered-error-border-color, ${csColorFunctional.error})`,
  borderedInfoBorderColor: css`var(--csc-paper-bordered-info-border-color, ${csColorFunctional.info})`,
  borderedSuccessBorderColor: css`var(--csc-paper-bordered-success-border-color, ${csColorFunctional.success})`,
  borderedWarningBorderColor: css`var(--csc-paper-bordered-warning-border-color, ${csColorFunctional.warning})`,

  flexDirection: css`var(--csc-paper-flex-direction, column)`
}

export const style: CSSResult = css`
  cse-paper {
    --cse-paper-border-radius: ${cscPaper.borderRadius};
    --cse-paper-row-gap: ${cscPaper.rowGap};
    --cse-paper-heading-gap: ${cscPaper.headingGap};
    --cse-paper-padding-y: ${cscPaper.paddingBlock};
    --cse-paper-padding-x: ${cscPaper.paddingInline};
    --cse-paper-height: ${cscPaper.height};
    --cse-paper-large-padding-y: ${cscPaper.largePaddingBlock};
    --cse-paper-large-padding-x: ${cscPaper.largePaddingInline};
    --cse-paper-extra-large-padding-y: ${cscPaper.extraLargePaddingBlock};
    --cse-paper-extra-large-padding-x: ${cscPaper.extraLargePaddingInline};

    --cse-paper-primary-background-color: ${cscPaper.primaryBackgroundColor};
    --cse-paper-secondary-background-color: ${cscPaper.secondaryBackgroundColor};
    --cse-paper-error-background-color: ${cscPaper.errorBackgroundColor};
    --cse-paper-info-background-color: ${cscPaper.infoBackgroundColor};
    --cse-paper-success-background-color: ${cscPaper.successBackgroundColor};
    --cse-paper-warning-background-color: ${cscPaper.warningBackgroundColor};

    --cse-paper-bordered-background-color: ${cscPaper.borderedBackgroundColor};
    --cse-paper-bordered-border-width: ${cscPaper.borderedBorderWidth};
    --cse-paper-bordered-primary-border-color: ${cscPaper.borderedPrimaryBorderColor};
    --cse-paper-bordered-secondary-border-color: ${cscPaper.borderedSecondaryBorderColor};
    --cse-paper-bordered-error-border-color: ${cscPaper.borderedErrorBorderColor};
    --cse-paper-bordered-info-border-color: ${cscPaper.borderedInfoBorderColor};
    --cse-paper-bordered-success-border-color: ${cscPaper.borderedSuccessBorderColor};
    --cse-paper-bordered-warning-border-color: ${cscPaper.borderedWarningBorderColor};

    --cse-paper-flex-direction: ${cscPaper.flexDirection};
  }
`
